import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { CustomControl } from "./CustomControl";
import { useRouteMatch } from "react-router";
import { push } from "connected-react-router";
import "./MultiSelectControl.scss";
import { selectIsPro } from "../../selectors/AccountSelectors";
import { showSubscriptionModal } from "../../components";

type Props = {
  position: L.ControlPosition;
};

export const MultiSelectControl = (props: Props) => {
  const { position } = props;

  const isPro = useSelector(selectIsPro);
  const dispatch = useDispatch();
  const active = useRouteMatch("/select/");

  const handleClick = () => {
    if (!isPro) {
      showSubscriptionModal(dispatch);
      return;
    }

    if (!active) {
      dispatch(push("/select"));
    } else {
      dispatch(push("/"));
    }
  };

  return (
    <CustomControl position={position}>
      <div className="multi-switch" onClick={handleClick}>
        <span className="label">MULTI</span>
        <div className={`switch-box ${active ? "checked" : "unchecked"}`}>
          <div className="icon-wrapper-container">
            <div className={`icon-wrapper cross ${!active ? "active" : ""}`}>
              <i className="far fa-times"></i>
            </div>
            <div className={`icon-wrapper check ${active ? "active" : ""}`}>
              <i className="far fa-check"></i>
            </div>
          </div>
        </div>
      </div>
    </CustomControl>
  );
};
